export const apiPath = '/v2/user_eligibilities';
const actionType = 'USER_ELIGIBILITIES';

export const bulkActionType = `${actionType}_BULK`;

export default actionType;
